document.addEventListener("DOMContentLoaded", function () {
    const items = document.querySelectorAll(
        "smooth-collapse.product-collapse-wrapper .product-collapse .prose ul.metafield-single_line_text_field-array li.metafield-single_line_text_field"
    );

    items.forEach((item) => {
        if (item.innerHTML.includes(":")) {
            let parts = item.innerHTML.split(":");
            item.innerHTML = `<strong>${parts[0]}:</strong>${parts.slice(1).join(":")}`;
        }
    });
});

document.addEventListener("DOMContentLoaded", function () {
const items = document.querySelectorAll(
    '.product-collapse-wrapper #product-details-new-products li'
);

items.forEach(li => {
    const text = li.textContent.trim().toLowerCase();
    
  if (!text || text.includes('story name')) {
    li.style.display = 'none';
  }
});
});